// extracted by mini-css-extract-plugin
export default {"HeroText":"styles_HeroText__maVbl","HeroText2":"styles_HeroText2__a1imf","Text":"styles_Text__CRsN2","float_up":"styles_float_up__vmhwj"};